export default {
    url:'http://172.105.52.225:82/api/v1'
    // url:'http://127.0.0.1:8888/api/v1'
}